import { EventEmitter, } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { ApiService } from "../api.service";
var CasePracticeReportBigComponent = (function () {
    function CasePracticeReportBigComponent(route, router, apiService) {
        this.route = route;
        this.router = router;
        this.apiService = apiService;
        this.onStartNextCase = new EventEmitter();
        this.onSwitchReport = new EventEmitter();
        this.onExit = new EventEmitter();
    }
    CasePracticeReportBigComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.top = 0;
        this.smallReportNumber = this.report.totalQuizCount;
        console.log(this.smallReportNumber);
        this.initializeKas();
        this.apiService
            .ajax({
            type: "post",
            url: "/api/getUserInfo",
            data: {},
        })
            .subscribe(function (result) {
            _this.status = result;
        });
    };
    CasePracticeReportBigComponent.prototype.ngAfterViewInit = function () {
        var html = document.documentElement;
        var htmlFontSize = html.clientWidth / 7.5;
        html.style.fontSize = htmlFontSize + "px";
        html.style.backgroundColor = "#3d3d6e";
        var starItems = $("#starWrap").children("ul").find("li");
        /*alert(JSON.stringify(this.report));*/
        if (this.isFirstReport) {
            this.drawStars(this.report.reports[this.currentIndex].totalKa, "onlyFirstStarsSvg");
        }
        else {
            this.drawStars(this.report.reports[this.currentIndex].totalKa, "nowStarsSvg");
            this.drawStars(this.firstReport.totalKa, "firstStarsSvg");
            var currentKas = this.report.reports[this.currentIndex].kas;
            var previousKas = this.report.reports[this.currentIndex - 1].kas;
            var length_1 = currentKas.length;
            if (this.firstEntry == 1) {
                for (var m = 0; m < length_1; m++) {
                    var stars = starItems.eq(m).children(".starItemRight").find("i");
                    var currentValue = parseInt(currentKas[m].value);
                    var previousValue = parseInt(previousKas[m].value);
                    if (currentValue < previousValue) {
                        for (var n = currentValue; n <= previousValue - 1; n++) {
                            stars.eq(n).addClass("retrogressAnimation");
                            console.log("<" + m + "," + n + ">----down");
                        }
                    }
                    else if (currentValue > previousValue) {
                        for (var n = previousValue; n <= currentValue - 1; n++) {
                            stars.eq(n).addClass("progressAnimation");
                            console.log("<" + m + "," + n + ">----up");
                        }
                    }
                }
            }
        }
    };
    CasePracticeReportBigComponent.prototype.initializeKas = function () {
        this.kas = this.report.reports[this.currentIndex].kas;
        this.firstReport = this.report.reports.find(function (o) { return o.type == "exercise"; });
        this.kasFirst = this.firstReport.kas;
        if (this.report.reports[this.currentIndex].id == this.firstReport.id) {
            this.isFirstReport = true;
        }
        else {
            this.isFirstReport = false;
        }
        var bigReportAnswer = document.getElementById("bigReportAnswer");
        var closeBtnReport2 = document.getElementById("closeBtnReport2");
        var bodyHeight = document.body.offsetHeight;
        bigReportAnswer.style.height = bodyHeight * 0.8 + "px";
        bigReportAnswer.style.marginTop = bodyHeight * 0.06 + "px";
        closeBtnReport2.style.top = bodyHeight * 1.88 + "px";
        this.enableRolling();
        if (this.currentIndex == this.smallReportNumber + 1) {
            this.order = "二";
        }
        else if (this.currentIndex == this.smallReportNumber + 2) {
            this.order = "三";
        }
        /*alert(this.currentIndex+"-------"+this.smallReportNumber);*/
    };
    CasePracticeReportBigComponent.prototype.getSmallReportNumber = function () {
        return this.report.totalQuizCount;
    };
    CasePracticeReportBigComponent.prototype.drawStars = function (quantity, id) {
        var svgDom = document.getElementById(id);
        svgDom.innerHTML = "";
        for (var i = 1; i <= quantity; i++) {
            var x_th = i % 5;
            if (x_th == 0) {
                x_th = 5;
            }
            var y_th = Math.floor((i - 1) / 5) + 1;
            var x_position = void 0;
            var y_position = void 0;
            var rotateString = void 0;
            if (x_th == 1) {
                x_position = 14 * (x_th - 1) + 3 * Math.random() + "";
            }
            else if (x_th == 5) {
                x_position = 14 * (x_th - 1) - 3 * Math.random() + "";
            }
            else {
                x_position = 14 * (x_th - 1) + 6 * Math.random() - 3 + "";
            }
            if (y_th == 1) {
                y_position = 100 - 14 * y_th - 3 * Math.random() + "";
            }
            else if (y_th == 7) {
                y_position = 100 - 14 * y_th + 3 * Math.random() + "";
            }
            else {
                y_position = 100 - 14 * y_th + 6 * Math.random() - 3 + "";
            }
            var x_position_rotate = x_position + 7;
            var y_position_rotate = y_position - 7;
            var randomAngle = Math.random() * 30 - 15;
            rotateString =
                "rotate(" +
                    randomAngle +
                    ", " +
                    x_position_rotate +
                    " " +
                    y_position_rotate +
                    ")";
            var image = document.createElementNS("http://www.w3.org/2000/svg", "image");
            image.setAttribute("x", x_position);
            image.setAttribute("y", y_position);
            image.setAttribute("width", "14");
            image.setAttribute("height", "14");
            image.setAttribute("transform", rotateString);
            image.href.baseVal = "../assets/picture/casepractice/star.svg";
            svgDom.appendChild(image);
        }
    };
    CasePracticeReportBigComponent.prototype.onDetailBtnClick = function () {
        var bigReportAnswer = document.getElementById("bigReportAnswer");
        var closeBtnReport2 = document.getElementById("closeBtnReport2");
        var bodyHeight = document.body.offsetHeight;
        this.scrollTop =
            document.body.scrollTop | document.documentElement.scrollTop;
        $("#shade").fadeIn(500);
        bigReportAnswer.style.top = "0rem";
        closeBtnReport2.style.top = bodyHeight * 0.88 + "px";
        document.getElementById("bigReportAnswer").scrollTo(0, 0);
        this.disableRolling();
        $("#wrap").addClass("fixed");
        $("#wrap").css({ top: -this.scrollTop });
    };
    CasePracticeReportBigComponent.prototype.onCloseBtnReportClick = function () {
        var bigReportAnswer = document.getElementById("bigReportAnswer");
        var closeBtnReport2 = document.getElementById("closeBtnReport2");
        $("#shade").fadeOut(500);
        bigReportAnswer.style.top = "15.34rem";
        closeBtnReport2.style.top = "25.76rem";
        this.enableRolling();
        $("#wrap").removeClass("fixed");
        document.documentElement.scrollTop = this.scrollTop;
    };
    CasePracticeReportBigComponent.prototype.redo = function () {
        var _this = this;
        this.apiService
            .resetExercise(this.report.reports[this.currentIndex].id)
            .subscribe(function (result) {
            var practiceId = result.practiceId;
            var learningPathId = result.learningPathId;
            var practiceMetaId = result.practiceMetaId;
            var link = [];
            if (learningPathId > 0) {
                link = ["case-practice", learningPathId, practiceId];
            }
            else {
                link = [practiceMetaId, "case-practice"];
            }
            _this.router.navigate(link);
        });
    };
    CasePracticeReportBigComponent.prototype.close = function () {
        this.onExit.emit(true);
    };
    CasePracticeReportBigComponent.prototype.startNextCase = function () {
        if (this.status == 1) {
            this.onStartNextCase.emit(true);
        }
        else {
            var link = ["form", "3"];
            this.router.navigate(link);
        }
    };
    CasePracticeReportBigComponent.prototype.switchReport = function (params) {
        this.onSwitchReport.emit(params);
        if (params.type == "exercise") {
            this.currentIndex = params.index;
            this.initializeKas();
            if (this.currentIndex == this.smallReportNumber) {
                this.drawStars(this.report.reports[this.currentIndex].totalKa, "onlyFirstStarsSvg");
            }
            else if (this.currentIndex > this.smallReportNumber) {
                this.drawStars(this.report.reports[this.currentIndex].totalKa, "nowStarsSvg");
                this.drawStars(this.report.reports[this.smallReportNumber].totalKa, "firstStarsSvg");
            }
        }
    };
    CasePracticeReportBigComponent.prototype.disableRolling = function () {
        document.getElementById("shade").ontouchstart = function (e) {
            e.preventDefault();
        };
        document.getElementById("closeBtnReport2").ontouchmove = function (e) {
            e.preventDefault();
        };
        //this.stopBodyScroll(true);
    };
    CasePracticeReportBigComponent.prototype.enableRolling = function () {
        //this.stopBodyScroll(false);
    };
    CasePracticeReportBigComponent.prototype.linkToPostSurvey = function () {
        var _this = this;
        this.apiService
            .ajax({
            type: "get",
            url: "/ddilearner/v1/getLearningPathMetaId/" + this.learningPathId,
        })
            .subscribe(function (result) {
            _this.learningPathMetaId = result.data;
            _this.apiService
                .getOrCreateLearningPath(_this.learningPathMetaId)
                .subscribe(function (result) {
                _this.learningPath = result;
                if (_this.learningPath.subItems.length == 3) {
                    _this.apiService
                        .ajax({
                        type: "get",
                        url: "/sr/learningtour",
                    })
                        .subscribe(function (result) {
                        _this.learningTour = result;
                        var link = ["survey", _this.learningTour.tour_id, 3, 2];
                        _this.router.navigate(link);
                    });
                }
                else {
                    var link = [
                        "survey",
                        _this.learningPath.id,
                        _this.learningPath.subItems[4].surveyMetaId,
                        1,
                    ];
                    _this.router.navigate(link);
                }
            });
        });
    };
    CasePracticeReportBigComponent.prototype.stopBodyScroll = function (isFixed) {
        var wrap = document.getElementById("wrap");
        if (isFixed) {
            this.top = window.scrollY;
            wrap.style.position = "fixed";
            wrap.style.top = -this.top + "px";
        }
        else {
            wrap.style.position = "";
            wrap.style.top = "0px";
            window.scrollTo(0, this.top); // 回到原先的top
        }
    };
    return CasePracticeReportBigComponent;
}());
export { CasePracticeReportBigComponent };



// WEBPACK FOOTER //
// ./src/app/case-practice-report-big/case-practice-report-big.component.ts.pre-build-optimizer.js